/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Email_SendingInputs */



/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Profile_Email_SendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_sending = /** @type {((inputs?: Profile_Email_SendingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_SendingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoi en cours...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invio in corso...")
	return /** @type {LocalizedString} */ ("Sending...")
});